var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExperiment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("title", null, "laboratory-drug-file"), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,11.5V16l-3.06,2.678a2.751,2.751,0,0,0-.94,2.071h0A2.75,2.75,0,0,0,15.249,23.5h5.5a2.75,2.75,0,0,0,2.75-2.75h0a2.75,2.75,0,0,0-.939-2.07L19.5,16V11.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.59,21.446l2.043-1.013a3.9,3.9,0,0,1,3.679.1h0a3.9,3.9,0,0,0,3.471.2L23.4,20.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,20.5h-9a1,1,0,0,1-1-1V4.5a1,1,0,0,1,1-1h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,3.5h3a1,1,0,0,1,1,1v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,2.5a2,2,0,0,0-4,0H5a.5.5,0,0,0-.5.5V6a.5.5,0,0,0,.5.5h7a.5.5,0,0,0,.5-.5V3a.5.5,0,0,0-.5-.5Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 11.5,
    x2: 21,
    y2: 11.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 9.5,
    x2: 12,
    y2: 9.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12.5,
    x2: 9.25,
    y2: 12.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 17.5 2.5 17.5 2.5 5.5 4.5 5.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12.5 5.5 14.5 5.5 14.5 9.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiment);
export default __webpack_public_path__ + "static/media/experiment.9f199c77.svg";
export { ForwardRef as ReactComponent };